module.exports = __webpack_public_path__ + "media/img/pages/companies/accenture-362aee86efc047458f9eda3d6e8529d8.png";